import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../baseUrl";

export const fetchSpaDetails = createAsyncThunk(
  "spa/fetchSpaDetails",
  async ({ hotelUrl, facilityUrl, language, thunkAPI }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/SPA/${language}/${hotelUrl}/${facilityUrl}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const spaDetailsSlice = createSlice({
  name: "spaDetails",
  initialState: {
    spaDetails: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpaDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSpaDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.spaDetails = action.payload;
      })
      .addCase(fetchSpaDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default spaDetailsSlice.reducer;
